import React, { forwardRef, useLayoutEffect } from 'react'
import { classNames } from '@zambezi/sdk/common'
import PropTypes from 'prop-types'

/**
 * Create a React Dropdown List Trigger Wrapper component
 *
 * @param {import('./interfaces').DropdownListTriggerWrapperProps} props
 * @param {import('react').Ref<HTMLElement>} ref
 * @returns {JSX.Element}
 */
function dropdownListTriggerWrapper (
  {
    className,
    children,
    'data-container': container,
    'data-position': position,
    dropdownList,
    style = {},
    ...props
  },
  ref
) {
  const isShown = !!children

  useLayoutEffect(() => {
    isShown && dropdownList.current && dropdownList.current.focus({ preventScroll: true })
  }, [isShown])

  return (
    <div
      className={classNames('zb-dropdownlist-trigger-wrapper', className, {
        'zb-dropdownlist-trigger-wrapper-is-shown': isShown
      })}
      hidden={!isShown}
      ref={ref}
      style={{ ...style, width: 'auto' }}
      {...props}
    >
      {children}
    </div>
  )
}

const DropdownListTriggerWrapper = forwardRef(dropdownListTriggerWrapper)

DropdownListTriggerWrapper.displayName = 'DropdownListTriggerWrapper'

DropdownListTriggerWrapper.propTypes = {
  className: PropTypes.string,
  dropdownList: PropTypes.shape({
    current: PropTypes.any
  })
}

export default DropdownListTriggerWrapper
